import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { EpostersService } from '../Services/eposters.service';

@Component({
  selector: 'app-congres-virtuel-eposters',
  templateUrl: './congres-virtuel-eposters.component.html',
  styleUrls: ['./congres-virtuel-eposters.component.scss']
})
export class CongresVirtuelEpostersComponent implements OnInit {

  posters = [];

  selected_eposter = null;
  selected_eposter_index = 0;

  epo_list_diplay = false;

  showPosterBig = false;

  constructor(private eposterservice:EpostersService, public cdr:ChangeDetectorRef) {
  
   }

  ngOnInit() {
    this.getAllPosters();
    console.log(this.posters);
  }

  getAllPosters(){
    this.posters = this.eposterservice.getAllPosters();
  }

  selectPoster(ep, index){
    this.selected_eposter = ep;
    this.selected_eposter_index = index;
    this.closePostersList();
  }

  goBack($event){
    $event.preventDefault();
    this.selected_eposter = null;
  }

  showPostersList(){
    /*this.epo_list_diplay = true;
    this.cdr.detectChanges();*/
    this.selected_eposter_index = 0;
    this.selected_eposter = this.posters[this.selected_eposter_index];
    this.cdr.detectChanges();
  }

  closePostersList(){
    this.epo_list_diplay = false;
  }

  getNextPoster(){
    if(this.selected_eposter_index < this.posters.length - 1){
      this.selected_eposter_index += 1;
      this.selected_eposter = this.posters[this.selected_eposter_index];
    }
  }

  getPreviousPoster(){
    if(this.selected_eposter_index > 0){
      this.selected_eposter_index -= 1;
      this.selected_eposter = this.posters[this.selected_eposter_index];
    }
  }

  showBigPosterPopup(){
    this.showPosterBig = true;
  }

  closeBigPosterPopup(){
    this.showPosterBig = false;
  }

  searchPoster(val){
    for(let i=0; i<this.posters.length; i++){
      if(this.posters[i].main_title.toLowerCase().indexOf(val.toLowerCase()) != -1 || this.posters[i].name.toLowerCase().indexOf(val.toLowerCase()) != -1){
        this.selected_eposter_index = i;
        this.selected_eposter = this.posters[i];
        return false;
      }
    }
  }

}
